import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiV1 } from "../Auth/Interceptor";

const initialStateValue = {
    modalType: '',
    modalDisplay: false,
    dropTrackList: {
        dropTrackList: [],
        loading: 'idle',
        error: null,
    },
    dropTrackProduct: {
        dropTrackProduct: {},
        loading: 'idle',
        error: null,
    },
    activeProduct: {},
    droptrackProductPage: {
        activeSection: 'recommendations',
        activeAlert: {
            type: null,
            startDate: null,
            endDate: null,
        },
    },
    couponsList: [],
    productDetails: {},
}

const fetchfetchDropTrackList = createAsyncThunk('dropTrack/fetchDropTrackList', async () => {
    const ACCESS_TOKEN = localStorage.getItem("accessToken");

    const headers = {
        Authorization: `Bearer ${ACCESS_TOKEN}`,
    };

    try {
        const response = await apiV1.get(`sellerDropTrack/getAll`, {
            headers: headers
        });
        return response.data.data;
    } catch(error) {
        throw error;
    }
});

const fetchfetchDropTrackProduct = createAsyncThunk('dropTrack/fetchDropTrackProduct', async (productId) => {
    const ACCESS_TOKEN = localStorage.getItem("accessToken");

    const headers = {
        Authorization: `Bearer ${ACCESS_TOKEN}`,
    };

    try {
        const response = await apiV1.get(`sellerDropTrack/${productId}`, {
            headers: headers
        });
        return response.data.data;
    } catch(error) {
        throw error;
    }
});

const dropTrackProductsSlice = createSlice({
    name: 'dropTrackProducts',
    initialState: initialStateValue,
    reducers: {
        setModalType: (state, action) => {
            state.modalType = action.payload;
        },
        openModal: (state, _) => {
            state.modalDisplay = true;
        },
        closeModal: (state, _) => {
            state.modalDisplay = false;
            state.modalType = '';
        },
        setActiveProduct: (state, action) => {
            state.activeProduct = action.payload;
        },
        setActiveSection: (state, action) => {
            state.droptrackProductPage.activeSection = action.payload;
        },
        setActionAlert: (state, action) => {
            state.droptrackProductPage.activeAlert = action.payload;
        },
        endActionAlert: (state, _) => {
            state.droptrackProductPage.activeAlert = initialStateValue.droptrackProductPage.activeAlert;
        },
        setCouponsList: (state, action) => {
            state.couponsList = action.payload;
        },
        setProductDetails: (state, action) => {
            state.productDetails = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
        // For DropTrack List
        .addCase(fetchfetchDropTrackList.pending, (state) => {
            state.dropTrackList.loading = 'loading';
        })
        .addCase(fetchfetchDropTrackList.fulfilled, (state, action) => {
            state.dropTrackList.loading = 'succeeded';
            state.dropTrackList.dropTrackList = action.payload;
        })
        .addCase(fetchfetchDropTrackList.rejected, (state, action) => {
            state.dropTrackList.loading = 'failed';
            state.dropTrackList.error = action.error.message;
        })
        // For DropTrack Product
        .addCase(fetchfetchDropTrackProduct.pending, (state) => {
            state.dropTrackProduct.loading = 'loading';
        })
        .addCase(fetchfetchDropTrackProduct.fulfilled, (state, action) => {
            state.dropTrackProduct.loading = 'succeeded';
            state.dropTrackProduct.dropTrackProduct = action.payload;
            state.dropTrackProduct.error = null;
        })
        .addCase(fetchfetchDropTrackProduct.rejected, (state, action) => {
            state.dropTrackProduct.loading = 'failed';
            state.dropTrackProduct.error = action.error.message;
        });
    },
});

export const {
    openModal,
    closeModal,
    setModalType,
    setActiveSection,
    setActiveProduct,
    setActionAlert,
    endActionAlert,
    setCouponsList,
    setProductDetails,
} = dropTrackProductsSlice.actions;

export {
    fetchfetchDropTrackList,
    fetchfetchDropTrackProduct
}

export default dropTrackProductsSlice.reducer;